<template>
    <div
        class="container-fluid weflix-admin-newVideo page-card w-100"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="text-left">
            <h1 class="card-title mb-2">Novo Vídeo</h1>
            <p class="card-subtitle mb-4 mb-md-0">
                Crie um novo vídeo para sua coleção
            </p>
        </div>
        <hr class="page-card__divider" />
        <div class="row" v-if="hasReady">
            <div class="col-12 col-md-6" style="padding: 0px!important;margin-bottom: 0px!important;">
                <div class="form-group" >
                    <div class="form-label">
                        <label>Status</label>
                    </div>
                    <div class="form-input">
                        <select class="form-control" v-model="status">
                            <option :value="true">Ativado</option>
                            <option :value="false">Desativado</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-label">
                        <label>Visibilidade</label>
                    </div>
                    <div class="form-input">
                        <select class="form-control" v-model="sample">
                            <option :value="true">Gratuito</option>
                            <option :value="false">Pago</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-label">
                        <label
                            >Título do Vídeo<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="form-control"
                            v-model="name"
                            placeholder="Título do vídeo"
                        />
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-label">
                        <label
                            >Descrição do vídeo<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-textarea full-descroption">
                        <textarea
                            class="form-control"
                            v-model="longDescription"
                            maxlength="300"
                            rows="4"
                            placeholder="Descrição do vídeo"
                        ></textarea>
                        <small class="char-counter"
                            >{{ (longDescription || '').length }}/300
                            caracteres</small
                        >
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6" style="padding: 0px!important;margin-bottom: 0px!important;">
                <!-- Upload de Vídeo -->
                <VideoUploadInput
                    label="Carregue novos vídeos para sua coleção"
                    :preview-url="path"
                    :accept="'.mp4, .avi'"
                    accept-text="Formatos aceitos: .mp4, .avi"
                    placeholder="Clique para fazer upload de vídeo"
                    @file-selected="handleVideoSelected"
                    @remove-preview="handleVideoRemove"
                />

                <!-- Capa do vídeo gerada do canvas -->
                <div class="image-upload-input">
                    <div class="form-label">
                        <label>Capa do vídeo</label>
                    </div>
                    
                    <!-- Preview da imagem capturada do vídeo -->
                    <div class="image-preview-wrapper" v-if="previewCoverVideo">
                        <div class="image-preview-container">
                            <img 
                                :src="previewCoverVideo" 
                                alt="Preview da capa"
                                class="image-preview"
                            />
                            <button 
                                class="remove-preview-btn" 
                                @click="handleImageRemove"
                                type="button"
                                title="Remover imagem"
                            >
                                <fa icon="fa-times" />
                            </button>
                            <div class="image-overlay" v-if="true">
                                <fa icon="fa-circle-play" />
                            </div>
                        </div>
                    </div>

                    <!-- Placeholder quando não há vídeo ou capa -->
                    <div class="upload-container" v-if="!previewCoverVideo">
                        <div class="file-wrapper">
                            <div class="file-label" style="cursor: default;">
                                <div class="upload-icon">
                                    <fa icon="fa-image" />
                                </div>
                                <div class="upload-text">
                                    <span class="upload-title">A capa será gerada automaticamente do vídeo</span>
                                    <span class="upload-subtitle">Pode ser substituída posteriormente editando o vídeo</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Vídeo oculto para processamento -->
                <video
                    ref="hiddenVideo"
                    style="display: none;"
                    @loadedmetadata="onVideoLoaded"
                    @seeked="onVideoSeeked"
                ></video>
                <canvas ref="thumbnailCanvas" style="display: none;"></canvas>
            </div>
        </div>
        <div
            class="d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7"
        >
            <v-btn
                variant="outlined"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                @click="
                    () =>
                        this.$router.push(
                            '/admin/colecao/' + this.currentCollections.id
                        )
                "
            >
                Cancelar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :width="$vuetify.display.xs ? 120 : 140"
                :disabled="!loaderImage"
                :class="{ disabled: !loaderImage }"
                @click="newVideo()"
            >
                Salvar
            </v-btn>
        </div>
    </div>
    <div class="pa-4 text-center" style="padding: 0px!important;">
        <v-dialog
            v-model="deleteItem"
            max-width="320"
            persistent
        >
            <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>
                    Deseja realmente excluir o vídeo {{ nameItem }}?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="cancel" text @click="closeDialog">Não</v-btn>
                    <v-btn class="accept" text @click="closeDialog">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <v-dialog v-model="showCopyDialog" class="copy-video-dialog" max-width="600">
        <v-card>
            <v-card-title>Copiar Vídeo</v-card-title>
            <v-card-text>
                <div class="move-controls">
                    <p>Selecione a coleção de origem</p>
                    <select v-model="selectedCollection" class="form-select" @change="putIdReuseVideoCollection()"> 
                        <option value="">Selecione uma coleção</option>
                        <option v-for="collection in collections" 
                                :key="collection.id"
                                :value="collection.id">
                            {{ collection.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-text>
                <div class="move-controls">
                    <p>Selecione o vídeo</p>
                    <select v-model="selectedLesson" class="form-select"
                    @change="getVideoById()"
                    >
                        <option value="">Selecione um vídeo</option>
                        <option v-for="videos in lessonByCollection" 
                                :key="videos.id"
                                :value="videos.id">
                            {{ videos.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="showCopyDialog = false">Cancelar</v-btn>
                <v-btn color="primary" text @click="copyVideo">Copiar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <UploadStatusContainer
      :uploads="activeUploads"
      @cancel-upload="handleCancelUpload"
    />
    <Loader :hasReady="hasReady"/>
</template>

<script>
import Sesson from '@/utils/Weflix/sesson';
import Videos from '@/utils/Weflix/videos';
import apiAWS from '@/utils/storage/aws';
import Loader from '@/components/Weflix/Loader.vue';
import LoaderImage from '@/components/Weflix/LoaderImage';
import UploadStatusContainer from '@/components/Weflix/UploadStatusContainer.vue';
import VideoUploadInput from '@/components/Weflix/VideoUploadInput.vue';
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
    data(){
        return{
            deleteItem: false,
            season:'',
            seasonSelected: null,
            noSeason: true,
            status: false,
            sample: false,
            name: '',
            longDescription: '',
            videoFile: null,
            coverVideo: '',
            previewCoverVideo:'',
            linkVideo: '',
            hasReady: true,
            loaderImage: true,
            tokenVideo: null,
            isUploading: false,
            isUploaded: false,
            progress: 0,
            showCopyDialog: false,
            selectedCollection: '',
            selectedLesson: '',
            collections: [],
            lessonByCollection: [],
            idReuseVideoCollection: null,
            path: null,
            activeUploads: [],
            uploadIdCounter: 0,
            videoObjectUrl: null,
        }
    },
    computed: {
        ...mapState(['token', 'currentCollections']),
    },
    components: {
        Loader,
        LoaderImage,
        UploadStatusContainer,
        VideoUploadInput
    },
    methods: {
        closeDialog(){
            this.deleteItem = false;
        },
        updateContentLongDescription(content) {
            this.longDescription = content;
        },
        async getVideoById(){
            const response = await Videos.getVideosById(this.token, this.selectedLesson);
            this.name = response.title || '';
            this.longDescription = response.description || '';
            this.coverVideo = response.videoThumbnail || '';
            this.previewCoverVideo = response.finalVideoThumbnail || '';
            this.sample = response.sample == 1 ? true : false;
            this.status = response.status == 1 ? true : false;
            this.path = response.path || '';
           
        },
        async copyVideo(){
            this.showCopyDialog = false;
        },
        async getSesson(){
            try {
                const response = await Sesson.getSessonByCollection(this.token, this.currentCollections.id);
                if(response.length > 0) {
                    if (Array.isArray(response)) {
                        this.season = response.sort((a, b) => a.order - b.order);
                        this.seasonSelected = this.season[0].id;
                        this.noSeason = false;
                    } else {
                        this.season = response;
                        this.seasonSelected = this.season[0].id;
                        this.noSeason = false;
                    }
                }
                else {
                    this.noSeason = true;
                    this.newSeason();
                }
            } catch (error) {
                console.error('Erro ao obter dados da coleção:', error);
            }
        },
        async newSeason(){
            const payload = {
                "course": {
                    "id": this.currentCollections.id
                },
                "title": "Temporada 1",
                "sample": 0
            }
            try {
                const response = await Sesson.createSesson(this.token, payload);
                this.noSeason = false;
                this.getSesson();
            } catch (error) {
                console.error('Erro ao criar temporada:', error);
            }
        },     
        async putFileAws(url, file){
            try {
                const response = await apiAWS.putFileAWS(url, file);
            } catch (error) {
                console.error('Erro ao enviar arquivo para AWS');
            }
        },
        handleVideoSelected(file, event) {
            this.uploadVideoAws(event);
            // Capturar frame do vídeo em 0.5s
            this.captureVideoThumbnail(file);
        },
        handleVideoRemove() {
            if (this.path) {
                URL.revokeObjectURL(this.path);
                this.path = null;
                this.videoFile = null;
            }
            // Limpar também a capa quando o vídeo for removido
            this.handleImageRemove();
        },
        handleImageRemove() {
            if (this.previewCoverVideo) {
                URL.revokeObjectURL(this.previewCoverVideo);
                this.previewCoverVideo = '';
                this.coverVideo = '';
            }
        },
        captureVideoThumbnail(file) {
            if (!file) return;
            
            this.loaderImage = false;
            const video = this.$refs.hiddenVideo;
            const canvas = this.$refs.thumbnailCanvas;
            
            if (!video || !canvas) {
                console.error('Elementos de vídeo ou canvas não encontrados');
                this.loaderImage = true;
                return;
            }
            
            // Limpar URL anterior se existir
            if (this.videoObjectUrl) {
                URL.revokeObjectURL(this.videoObjectUrl);
                this.videoObjectUrl = null;
            }
            
            // Criar URL do vídeo
            const videoUrl = URL.createObjectURL(file);
            video.src = videoUrl;
            this.videoObjectUrl = videoUrl;
            
            // Adicionar tratamento de erro
            video.onerror = () => {
                console.error('Erro ao carregar vídeo para captura de thumbnail');
                this.loaderImage = true;
                if (this.videoObjectUrl) {
                    URL.revokeObjectURL(this.videoObjectUrl);
                    this.videoObjectUrl = null;
                }
            };
        },
        onVideoLoaded() {
            const video = this.$refs.hiddenVideo;
            if (!video) return;
            
            // Verificar se o vídeo tem duração válida
            if (video.duration && video.duration > 0) {
                // Pular para 0.5 segundos (ou início se o vídeo for menor)
                video.currentTime = Math.min(0.5, video.duration - 0.1);
            } else {
                // Se não conseguir obter a duração, tentar mesmo assim
                video.currentTime = 0.5;
            }
        },
        async onVideoSeeked() {
            const video = this.$refs.hiddenVideo;
            const canvas = this.$refs.thumbnailCanvas;
            
            if (!video || !canvas) {
                console.error('Elementos de vídeo ou canvas não encontrados');
                this.loaderImage = true;
                return;
            }
            
            // Verificar se o vídeo tem dimensões válidas
            if (!video.videoWidth || !video.videoHeight) {
                console.error('Vídeo não possui dimensões válidas');
                this.loaderImage = true;
                return;
            }
            
            try {
                // Configurar dimensões do canvas
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                
                // Desenhar frame do vídeo no canvas
                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                
                // Converter canvas para blob
                canvas.toBlob(async (blob) => {
                    if (!blob) {
                        console.error('Erro ao gerar thumbnail do vídeo');
                        this.loaderImage = true;
                        return;
                    }
                    
                    // Limpar preview anterior se existir
                    if (this.previewCoverVideo) {
                        URL.revokeObjectURL(this.previewCoverVideo);
                    }
                    
                    // Criar preview
                    this.previewCoverVideo = URL.createObjectURL(blob);
                    
                    // Criar arquivo a partir do blob para upload
                    const file = new File([blob], 'thumbnail.jpg', { type: 'image/jpeg' });
                    
                    // Fazer upload da imagem
                    try {
                        const response = await apiAWS.getSignatureImage(this.token, file.name);
                        await this.putFileAws(response.url, file);
                        this.coverVideo = response.token;
                        this.loaderImage = true;
                    } catch (error) {
                        console.error('Erro na geração do TOKEN AWS', error);
                        this.loaderImage = true;
                    }
                }, 'image/jpeg', 0.95);
                
            } catch (error) {
                console.error('Erro ao capturar thumbnail do vídeo:', error);
                this.loaderImage = true;
            }
        },
        async uploadVideoAws(event) {
            try {
                const file = event.target.files[0];
                if (!file) return;

                const uploadId = ++this.uploadIdCounter;
                const filename = file.name;
                const fileSize = file.size;
                
                // Criar entrada de upload
                const uploadEntry = {
                    id: uploadId,
                    filename: filename,
                    fileSize: fileSize,
                    progress: 0,
                    speed: 0,
                    isUploading: false,
                    isCompleted: false,
                    error: null,
                    startTime: null,
                    lastProgressTime: null,
                    lastProgressBytes: 0
                };
                
                this.activeUploads.push(uploadEntry);
                
                // Criar preview local do vídeo
                this.path = URL.createObjectURL(file);
                this.videoFile = file;
                
                const fileExtension = file.type.split('/').pop();
                const CHUNK_SIZE = 4 * 1024 * 1024 * 1024;
                const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

                const response = await apiAWS.getSignatureVideo(this.token, totalChunks, fileExtension, CHUNK_SIZE);

                if (!response) {
                    throw new Error('URLs de upload inválidas');
                }

                this.tokenVideo = response;
                await this.putVideoAws(response.urls, file, totalChunks, CHUNK_SIZE, uploadId);

            } catch (error) {
                console.error('Erro ao enviar arquivo para AWS', error);
                const uploadIndex = this.activeUploads.findIndex(u => u.id === this.uploadIdCounter);
                if (uploadIndex !== -1) {
                    this.activeUploads[uploadIndex].error = error.message || 'Erro no upload';
                    this.activeUploads[uploadIndex].isUploading = false;
                }
            }
        },
        async putVideoAws(urlArray, file, totalChunks, chunkSize, uploadId) {
            const uploadIndex = this.activeUploads.findIndex(u => u.id === uploadId);
            if (uploadIndex === -1) return;

            const uploadEntry = this.activeUploads[uploadIndex];
            uploadEntry.isUploading = true;
            uploadEntry.startTime = Date.now();
            uploadEntry.lastProgressTime = Date.now();
            uploadEntry.lastProgressBytes = 0;

            this.isUploading = true;
            this.isUploaded = false;
            let successfulUploads = 0;
            let totalProgress = 0;
            let progressArray = new Array(totalChunks).fill(0);
            let totalBytesUploaded = 0;

            for (let i = 0; i < totalChunks; i++) {
                const start = i * chunkSize;
                const end = Math.min(start + chunkSize, file.size);
                const chunk = file.slice(start, end);
                const chunkSizeActual = end - start;

                try {
                    await apiAWS.putVideoAWS(urlArray[i].url, chunk, (progress) => {
                        const currentTime = Date.now();
                        const chunkProgress = progress / 100;
                        const chunkBytesUploaded = chunkSizeActual * chunkProgress;
                        const totalChunkBytesUploaded = i * chunkSize + chunkBytesUploaded;
                        
                        progressArray[i] = progress;
                        totalProgress = progressArray.reduce((a, b) => a + b, 0) / totalChunks;
                        this.progress = totalProgress;
                        
                        // Calcular velocidade
                        if (uploadEntry.lastProgressTime) {
                            const timeDiff = (currentTime - uploadEntry.lastProgressTime) / 1000; // em segundos
                            if (timeDiff > 0) {
                                const bytesDiff = totalChunkBytesUploaded - uploadEntry.lastProgressBytes;
                                const speed = bytesDiff / timeDiff; // bytes por segundo
                                uploadEntry.speed = speed;
                            }
                        }
                        
                        uploadEntry.progress = totalProgress;
                        uploadEntry.lastProgressTime = currentTime;
                        uploadEntry.lastProgressBytes = totalChunkBytesUploaded;
                    });

                    successfulUploads++;
                    totalBytesUploaded += chunkSizeActual;
                    
                    if (successfulUploads === totalChunks) {
                        uploadEntry.isCompleted = true;
                        uploadEntry.isUploading = false;
                        uploadEntry.progress = 100;
                        uploadEntry.speed = 0;
                        this.isUploaded = true;
                        this.isUploading = false;
                        
                        // Remover upload após 3 segundos
                        setTimeout(() => {
                            const index = this.activeUploads.findIndex(u => u.id === uploadId);
                            if (index !== -1) {
                                this.activeUploads.splice(index, 1);
                            }
                        }, 3000);
                    }
                } catch (error) {
                    console.error(`Erro no upload da parte ${i + 1}:`, error);
                    uploadEntry.error = error.message || 'Erro no upload';
                    uploadEntry.isUploading = false;
                    this.isUploading = false;
                    this.isUploaded = false;
                    throw error;
                }
            }
        },
        handleCancelUpload(uploadId) {
            const uploadIndex = this.activeUploads.findIndex(u => u.id === uploadId);
            if (uploadIndex !== -1) {
                this.activeUploads[uploadIndex].isUploading = false;
                this.activeUploads[uploadIndex].error = 'Upload cancelado pelo usuário';
                
                // Limpar preview se for o upload atual
                if (this.activeUploads[uploadIndex].id === this.uploadIdCounter) {
                    if (this.path) {
                        URL.revokeObjectURL(this.path);
                        this.path = null;
                        this.videoFile = null;
                    }
                }
                
                // Remover após um tempo
                setTimeout(() => {
                    const index = this.activeUploads.findIndex(u => u.id === uploadId);
                    if (index !== -1) {
                        this.activeUploads.splice(index, 1);
                    }
                }, 2000);
            }
        },
        async getCollections(){
            try {
                const response = await Videos.listCollections(this.token);
                this.collections = response.map(item => ({
                    id: item.id,
                    name: item.name,
                    status: item.status
                }));
            } catch (error) {
                console.error('Erro ao obter coleções:', error);
            }
        },
        putIdReuseVideoCollection(){
            this.idReuseVideoCollection = this.selectedCollection;
            this.getLessonByCollections();
        },
        async getLessonByCollections(){
            try {
                const response = await Videos.listLessonByCollections(this.token, this.idReuseVideoCollection);
                this.lessonByCollection = response;
            } catch (error) {
                console.error('Erro ao obter aulas:', error);
            }
        },
        /** Corpo do POST /file/videoteca/upload: lesson direta ou dentro de data/body/result. */
        extractCreatedLessonId(created) {
            if (created == null) return null;
            if (typeof created === 'string') {
                const t = created.trim();
                if (!t) return null;
                if (t.startsWith('{') || t.startsWith('[')) {
                    try {
                        return this.extractCreatedLessonId(JSON.parse(t));
                    } catch {
                        return null;
                    }
                }
                return t;
            }
            if (typeof created !== 'object') return null;
            if (created.id != null && created.id !== '') {
                return String(created.id);
            }
            const nests = [
                created.data,
                created.body,
                created.result,
                created.payload,
                created.lesson,
                created.content,
            ];
            for (const n of nests) {
                if (n != null && typeof n === 'object' && !Array.isArray(n)) {
                    if (n.id != null && n.id !== '') return String(n.id);
                }
            }
            return null;
        },
        miniLessonsAsArray(mini) {
            if (Array.isArray(mini)) return mini;
            if (mini?.list != null) return mini.list;
            if (mini?.content != null) return mini.content;
            return [];
        },
        async resolveLessonIdAfterVideotecaCreate(createdPayload) {
            let id = this.extractCreatedLessonId(createdPayload);
            if (id) return id;
            const title = (this.name || '').trim();
            const pickByTitle = (list, titleKey = 'title') => {
                if (!list?.length) return null;
                const same = list.filter(
                    (v) => (v[titleKey] || v.name || '').trim() === title
                );
                const row =
                    same.length > 0 ? same[same.length - 1] : list[list.length - 1];
                return row?.id != null ? String(row.id) : null;
            };
            if (this.seasonSelected) {
                try {
                    const mod = await Videos.getVideosBySesson(
                        this.token,
                        this.seasonSelected
                    );
                    id = pickByTitle(mod?.list || [], 'title');
                    if (id) return id;
                } catch (e) {
                    console.error('Erro ao listar vídeos do módulo:', e);
                }
            }
            if (this.currentCollections?.id) {
                try {
                    const mini = await Videos.listLessonByCollections(
                        this.token,
                        this.currentCollections.id
                    );
                    const list = this.miniLessonsAsArray(mini);
                    id = pickByTitle(list, 'name');
                    if (id) return id;
                } catch (e) {
                    console.error('Erro ao listar aulas da coleção (mini):', e);
                }
            }
            return null;
        },
        async newVideo(){
            this.hasReady = false;

            const payload = {
                type: 6,
                title: this.name,
                description: this.longDescription,
                idModule: this.seasonSelected,
                status: this.status === true ? 1 : 0,
                token: this.tokenVideo && this.tokenVideo.urls ? this.tokenVideo.urls.map(item => item.token) : [],
                uploadId: this.tokenVideo && this.tokenVideo.uploadId ? this.tokenVideo.uploadId : null,
                videoThumbnail: this.coverVideo,
                sample: this.sample === true ? 1 : 0,
                favourite: null
            };

            try {
                const created = await apiAWS.createVideoVideoteca(
                    this.token,
                    payload
                );
                let lessonId = this.extractCreatedLessonId(created);
                if (!lessonId) {
                    lessonId = await this.resolveLessonIdAfterVideotecaCreate(
                        created
                    );
                }
                if (lessonId != null && lessonId !== '') {
                    await this.$router.replace({
                        path: `/admin/video/${encodeURIComponent(lessonId)}`,
                    });
                } else {
                    this.notify(
                        'Vídeo criado, mas não foi possível abrir a edição. Abra-o na lista da coleção.',
                        'warning'
                    );
                    await this.$router.replace(
                        '/admin/colecao/' + this.currentCollections.id
                    );
                }
            } catch (error) {
                console.error('Erro ao enviar arquivo para AWS', error);
                this.notify(
                    'Erro ao criar o vídeo. Tente novamente.',
                    'error'
                );
            } finally {
                this.hasReady = true;
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    },  
    created(){
        this.getSesson();
        this.getCollections();
    },
    beforeUnmount() {
        // Limpar URLs criadas
        if (this.videoObjectUrl) {
            URL.revokeObjectURL(this.videoObjectUrl);
        }
        if (this.path) {
            URL.revokeObjectURL(this.path);
        }
        if (this.previewCoverVideo) {
            URL.revokeObjectURL(this.previewCoverVideo);
        }
    }
}
</script>

<style>
@import url(./global.css);
@import url(@/css/weflix/admin/newVideo.css);

.uploadVideoBox {
    border: none !important;
    padding: 0px !important;
}

.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #150065;
    font-weight: 500;
}

.loading-spinner svg {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.upload-complete {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #28a745;
    font-weight: 500;
}

.upload-complete svg {
    color: #28a745 !important;
}

/* Estilos para o componente de capa gerada do vídeo */
.image-upload-input {
    width: 100%;
    margin-top: 1.5rem;
}

.image-preview-wrapper {
    margin-bottom: 1rem;
}

.image-preview-container {
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    padding: 8px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
}

.image-preview {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: cover;
    border-radius: 8px;
    display: block;
}

.remove-preview-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    transition: all 0.2s ease;
    z-index: 10;
}

.remove-preview-btn:hover {
    background: rgba(220, 53, 69, 0.9);
    transform: scale(1.1);
}

.image-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 3rem;
    opacity: 0.9;
    pointer-events: none;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    z-index: 5;
}

.upload-container {
    width: 100%;
}

.file-wrapper {
    position: relative;
    width: 100%;
}

.file-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2.5rem 1.5rem;
    border: 1px solid #e5e7eb !important;
    border-style: solid !important;
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.2s ease;
    text-align: center;
    min-height: 180px;
    height: 180px;
}

.upload-icon {
    margin-bottom: 1rem;
    color: #150065;
    font-size: 3rem;
    opacity: 0.8;
    transition: all 0.3s ease;
}

.upload-text {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.upload-title {
    font-weight: 600;
    color: #1a1a1a;
    font-size: 1rem;
}

.upload-subtitle {
    font-size: 0.75rem;
    color: #6b7280;
}

@media (max-width: 768px) {
    .file-label {
        padding: 2rem 1rem;
        min-height: 160px;
    }

    .upload-icon {
        font-size: 2.5rem;
    }

    .image-preview {
        max-height: 250px;
    }
}
</style>